import { dateRangeFormFields } from '@openx/components-core/lib/DateRangePickerField/constants.ts';
import { isAfter, isValid, startOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { date, object } from 'yup';
import { getDealInsightsSupportedDateRange } from '../utils/getDealInsightsSupportedDateRange.ts';

export const useDateRangeValidationSchema = (maxDate: Date) => {
  const { t } = useTranslation();
  const { minDate } = getDealInsightsSupportedDateRange();

  return object().shape({
    [dateRangeFormFields.START_DATE]: date()
      .required(t('Start Date is required'))
      .typeError(t('Start date should be in format YYYY-MM-DD'))
      .min(minDate, t('Start date must be within the last 180 days.'))
      .test('is-before-max', "Start date cannot exceed yesterday's date.", value => {
        if (!value) {
          return true;
        }
        return !isAfter(startOfDay(value), maxDate);
      })
      .when(dateRangeFormFields.END_DATE, ([endDateValue], schema) => {
        if (endDateValue && isValid(endDateValue)) {
          return schema.test({
            message: t('Start Date cannot be after End Date.'),
            test: (startDateValue: Date): boolean => {
              return !isAfter(startOfDay(startDateValue), endDateValue);
            },
          });
        }

        return schema;
      }),
    [dateRangeFormFields.END_DATE]: date()
      .test('is-before-max', "End date cannot exceed yesterday's date.", value => {
        if (!value) {
          return true;
        }
        return !isAfter(startOfDay(value), maxDate);
      })
      .typeError(t('End date should be in format YYYY-MM-DD'))
      .nullable(),
  });
};
